import { Link } from "react-router-dom";
import { BRAND } from "@/config/site";

export const Logo = ({ tone = "light", to = "/", testId = "nav-logo" }) => (
  <Link to={to} data-testid={testId} className="group inline-flex items-center gap-2.5">
    <span
      className={`grid h-8 w-8 shrink-0 place-items-center sm:h-9 sm:w-9 rounded-full border ${
        tone === "light" ? "border-gold/50 text-gold" : "border-navy/20 text-navy"
      } transition-transform duration-500 group-hover:rotate-[20deg]`}
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 15.5 21 7l-4.5 9.5-4-2.5L9 18l-.5-4.5L3 15.5Z" strokeLinejoin="round" />
      </svg>
    </span>
    <span className={`whitespace-nowrap font-display text-base sm:text-xl ${tone === "light" ? "text-ivory" : "text-navy"}`}>
      {BRAND.name}
    </span>
  </Link>
);

export const DemoTag = ({ children = "Exemple fictif", className = "", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border border-dashed border-current px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${className}`}
  >
    {children}
  </span>
);

export const BusinessBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full bg-navy/80 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-gold backdrop-blur-md ${className}`}
  >
    Business
  </span>
);
